import { IntegrationProvider } from '../graphql/enums';

export interface IntegrationConnection {
  workspaceId: string;
  provider: IntegrationProvider;
  connected: boolean;
  connectedBy: {
    id: string;
    name: { first: string | null; last: string | null } | null;
  } | null;
  connectedAt: string | null;
  lastValidatedAt: string | null;
}

export interface StartIntegrationConnectionInput {
  provider: IntegrationProvider;
  redirectUri: string;
}

export interface StartIntegrationConnectionResult {
  authorizeUrl: string;
}

export interface CompleteIntegrationConnectionInput {
  provider: IntegrationProvider;
  code: string;
  state: string;
}

export interface DisconnectIntegrationInput {
  provider: IntegrationProvider;
}

export interface IntegrationWorkspaceVariables {
  workspaceId: string;
}
